/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./extra-manage.vue?vue&type=template&id=4462fb51&"
import script from "./extra-manage.vue?vue&type=script&lang=js&"
export * from "./extra-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports